// extracted by mini-css-extract-plugin
export var container = "style-module--container--39bdd";
export var fotter_main_group = "style-module--fotter_main_group--cb15d";
export var logo_box = "style-module--logo_box--abf94";
export var nav = "style-module--nav--30f57";
export var nav_copyright = "style-module--nav_copyright--132f3";
export var site = "style-module--site--65174";
export var site_item = "style-module--site_item--c3c2e";
export var site_list = "style-module--site_list--702cf";
export var sns = "style-module--sns--1a31f";
export var sns_item = "style-module--sns_item--6e163";
export var sns_list = "style-module--sns_list--244b5";